import dayjs, { Dayjs } from "dayjs";
import {
  ICaseInformation,
  ICaseInformationModel,
} from "us.collection.case/reducers/CaseInformation/Interfaces";
import { StandardDateFromat } from "../Constants";

export const GetFormikCaseInfo = (
  caseInfo: ICaseInformationModel
): ICaseInformation | {} => {
  return caseInfo.data
    ? {
        ...caseInfo.data,
        debtwarningDate:GetValidDate(caseInfo.data.debtwarningDate),
        boDate:GetValidDate(caseInfo.data.boDate),
        dcfDate:GetValidDate(caseInfo.data.dcfDate),
        vtDate:GetValidDate(caseInfo.data.vtDate),
        lastBODate:GetValidDate(caseInfo.data.lastBODate),
        lastDistraintDate:GetValidDate(caseInfo.data.lastDistraintDate),
        lastCourtDate:GetValidDate(caseInfo.data.lastCourtDate),
        migratedDate:GetValidDate(caseInfo.data.migratedDate),
        objectionDate:GetValidDate(caseInfo.data.objectionDate),
        obsoleteDate:GetValidDate(caseInfo.data.obsoleteDate),
        interestStopDate:GetValidDate(caseInfo.data.interestStopDate),
        closeDate:GetValidDate(caseInfo.data.closeDate),
        nextDueDate:GetValidDate(caseInfo.data.nextDueDate),
        caseDueDate:GetValidDate(caseInfo.data.caseDueDate)
      }
    : {};
};

export const GetValidDate = (dateString:string):Dayjs|undefined =>{
  return dayjs(dateString, StandardDateFromat).isValid()
  ?dayjs(dateString, StandardDateFromat)
  :undefined
}

export const GetValidDateStandardString = (date:Dayjs):string =>{
  return dayjs(date).isValid()
  ?dayjs(date).format(StandardDateFromat)
  :''
}
